/**
 * @generated SignedSource<<93893314d72a2d3479e109a030a6a195>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RequestModalSelectProject_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "RequestModalSelectProject_user";
};
export type RequestModalSelectProject_user$key = {
  readonly " $data"?: RequestModalSelectProject_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"RequestModalSelectProject_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RequestModalSelectProject_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "1cac9cf8561761ddbbb5a87792a66539";

export default node;
